import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, ProjectService,} from '../../_services/index';

import {User} from '../../_models/index';

import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';


import {LoginHelper} from '../../helpers';

const defaultDialogConfig = new MatDialogConfig();


@Component({
    standalone: false,
  selector: "project-access-rights-component",
  templateUrl: 'project.access.rights.component.html',
  styleUrls: ['./project.access.rights.component.scss'],
})

export class ProjectAccessRightsComponent implements OnInit {
  loading = false;
  userId: number;
  user: User;
  oldPassword: string;
  newPassword: string;
  confirmationPassword: string;
  msg: string;
  public accessRightsSettings: any[];
  rowGroupMetadata: any = {};

  constructor(
    public dialogRef: MatDialogRef<ProjectAccessRightsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public projectService: ProjectService,
    public alertService: AlertService) {

    this.userId = route.snapshot.params['userId'];
  }

  ngOnInit() {
    //console.log(this.data.user.userId);
      const tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return;
    }

    this.projectService.getAccessRights(this.data.project.projectId).subscribe(
      data => {
        this.accessRightsSettings = data;
        this.updateRowGroupMetaData();
      });
  }

  onChange() {
    this.loading = true;

    this.projectService.saveAccessRights(this.data.project.projectId, this.accessRightsSettings)
      .subscribe(
        data => {
          this.alertService.success('Access rights were changed', true);

          this.loading = false;

          this.onClose();
        },
        error => {
          this.loading = false;
          this.msg = error;
        });
  }

  updateRowGroupMetaData() {
      const data = this.accessRightsSettings;
      const field = "userId";
      this.rowGroupMetadata = {};
    if (data) {
      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData[field];
        if (i == 0) {
          this.rowGroupMetadata[brand] = { index: 0, size: 1 };
        }
        else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData[field];
          if (brand === previousRowGroup)
            this.rowGroupMetadata[brand].size++;
          else
            this.rowGroupMetadata[brand] = { index: i, size: 1 };
        }
      }
    }

  }

  onClose(): void {
    this.dialogRef.close();
  }

}
